import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

import { path } from "../../../utils";
import Footer from "../inc/Footer";
class RefundPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <>
        <div className="container">
          <div
            style={{
              width: "100%",
              textAlign: "left",
              marginTop: 30,
              marginBottom: 60,
            }}
          >
            <Link to="/">
              <img src="static/picture/logo.png" alt="none" />
            </Link>
          </div>
          <h3>FIBO</h3>
          <p>
            We will be at FIBO, the world's largest fitness event, and are
            excited and looking forward to meeting everyone and learning how
            Anovator can help your business thrive.
          </p>
          <p>
            Experience Anovator, attracting new members and retaining more by
            providing body composition analysis for the best workouts and
            training programs.
          </p>
          <p>
            Visit our booth and we'll be happy to provide you with a personal
            body reading to understand your
            <Link to="/product/a5">body composition</Link>!
          </p>
          <p>
            Want to learn more? Visit our
            <Link to={path.HOME}>Fitness</Link>
            page or get in touch!
          </p>
          <p>
            <img src="/static/images/fibo-map.png" alt="none" />
          </p>
          <p>
            The leading European&nbsp;fitness and wellness&nbsp;trade
            fair&nbsp;FIBO&nbsp;will be held between&nbsp;13th – 16th April
            2023. The organisers of&nbsp;FIBO 2023&nbsp;estimate over 100 000
            participants will gather in&nbsp;Koelnmesse, since last year's fair
            restart returned higher than anticipated turnout.
          </p>
          <p>
            FIBO 2023&nbsp;is the flagship platform for business, networking and
            innovation in the world of fitness. Each edition of the show
            attracts&nbsp;decision-makers, start-ups, studio operators,
            trainers&nbsp;and&nbsp;healthcare professionals&nbsp;from all over
            the world. Past editions have recorded visitors with&nbsp;specific
            investments&nbsp;in mind and high numbers of&nbsp;on the spot sales,
            making FIBO 2023 a very lucrative meeting hub for business in the
            fitness and wellness sector. Exhibiting businesses showcase
            their&nbsp;highest-quality products, fitness equipment and services
            arranged within one of the following areas:&nbsp;Training
            Equipment", "Wellness &amp; Spa", "Fashion &amp;
            Beauty"&nbsp;and&nbsp;"Healthy Sports Nutrition"
          </p>
          <p>
            The first part of the&nbsp;FIBO 2023&nbsp;will be dedicated to trade
            visitors, allowing all participants to&nbsp;foster promising
            partnerships and generate innovative ideas. The weekend days of the
            trade fair are open to the public, encouraging the engagement of the
            end-user.
          </p>
          <p>
            The&nbsp;FIBO Innovation Award&nbsp;ceremony will offer visitors an
            excellent indication of the future of fitness products and services.
            Since&nbsp;FIBO&nbsp;attracts predominantly international visitors
            to&nbsp;Cologne&nbsp;hotels during the trade fair dates will be in
            high demand.
          </p>
          <p style={{ textAlign: "center", marginTop: 40, marginBottom: 40 }}>
            <img src="/static/images/fibo.png" alt="none" />
          </p>
        </div>

        <Footer />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RefundPolicy)
);
